/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPropertyById200ResponsePolicy } from './get-property-by-id200-response-policy';
import {
    GetPropertyById200ResponsePolicyFromJSON,
    GetPropertyById200ResponsePolicyFromJSONTyped,
    GetPropertyById200ResponsePolicyToJSON,
    GetPropertyById200ResponsePolicyToJSONTyped,
} from './get-property-by-id200-response-policy';
import type { MealTypeView } from './meal-type-view';
import {
    MealTypeViewFromJSON,
    MealTypeViewFromJSONTyped,
    MealTypeViewToJSON,
    MealTypeViewToJSONTyped,
} from './meal-type-view';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';

/**
 * 
 * @export
 * @interface GetPropertyById200Response
 */
export interface GetPropertyById200Response {
    /**
     * List of meals from property
     * @type {Array<MealTypeView>}
     * @memberof GetPropertyById200Response
     */
    mealTypes: Array<MealTypeView>;
    /**
     * Property ID
     * @type {string}
     * @memberof GetPropertyById200Response
     */
    id: string;
    /**
     * Property name
     * @type {string}
     * @memberof GetPropertyById200Response
     */
    name: string;
    /**
     * Property address
     * @type {string}
     * @memberof GetPropertyById200Response
     */
    address: string;
    /**
     * Star rating of the property
     * @type {number}
     * @memberof GetPropertyById200Response
     */
    stars?: number;
    /**
     * List of available services
     * @type {Array<string>}
     * @memberof GetPropertyById200Response
     */
    services: Array<string>;
    /**
     * Property images
     * @type {Array<TravelineResourceDto>}
     * @memberof GetPropertyById200Response
     */
    images: Array<TravelineResourceDto>;
    /**
     * Detailed property description
     * @type {string}
     * @memberof GetPropertyById200Response
     */
    description: string;
    /**
     * 
     * @type {GetPropertyById200ResponsePolicy}
     * @memberof GetPropertyById200Response
     */
    policy: GetPropertyById200ResponsePolicy;
    /**
     * Latitude
     * @type {number}
     * @memberof GetPropertyById200Response
     */
    latitude: number | null;
    /**
     * Longitude
     * @type {number}
     * @memberof GetPropertyById200Response
     */
    longitude: number | null;
    /**
     * Рейтинг отеля
     * @type {number}
     * @memberof GetPropertyById200Response
     */
    rating: number;
    /**
     * Количество отзывов
     * @type {number}
     * @memberof GetPropertyById200Response
     */
    reviewCount: number;
}

/**
 * Check if a given object implements the GetPropertyById200Response interface.
 */
export function instanceOfGetPropertyById200Response(value: object): value is GetPropertyById200Response {
    if (!('mealTypes' in value) || value['mealTypes'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('services' in value) || value['services'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('rating' in value) || value['rating'] === undefined) return false;
    if (!('reviewCount' in value) || value['reviewCount'] === undefined) return false;
    return true;
}

export function GetPropertyById200ResponseFromJSON(json: any): GetPropertyById200Response {
    return GetPropertyById200ResponseFromJSONTyped(json, false);
}

export function GetPropertyById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPropertyById200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'mealTypes': ((json['mealTypes'] as Array<any>).map(MealTypeViewFromJSON)),
        'id': json['id'],
        'name': json['name'],
        'address': json['address'],
        'stars': json['stars'] == null ? undefined : json['stars'],
        'services': json['services'],
        'images': ((json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
        'description': json['description'],
        'policy': GetPropertyById200ResponsePolicyFromJSON(json['policy']),
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'rating': json['rating'],
        'reviewCount': json['reviewCount'],
    };
}

  export function GetPropertyById200ResponseToJSON(json: any): GetPropertyById200Response {
      return GetPropertyById200ResponseToJSONTyped(json, false);
  }

  export function GetPropertyById200ResponseToJSONTyped(value?: GetPropertyById200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mealTypes': ((value['mealTypes'] as Array<any>).map(MealTypeViewToJSON)),
        'id': value['id'],
        'name': value['name'],
        'address': value['address'],
        'stars': value['stars'],
        'services': value['services'],
        'images': ((value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
        'description': value['description'],
        'policy': GetPropertyById200ResponsePolicyToJSON(value['policy']),
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'rating': value['rating'],
        'reviewCount': value['reviewCount'],
    };
}

